export default function Footer() {
    return(
        <footer>
            <small>Copyright © 2025 Code78.net - All Rights Reserved.</small>
        </footer>
    );
}